module.exports = __webpack_public_path__ + "img/trunk.92fa562a.svg";